import GlobalStyles from "./GlobalStyles";

export { GlobalStyles };

export default GlobalStyles;
